import Cookies from 'js-cookie';
import axios from 'axios'
import qs from 'qs';
import Vue from 'vue'
import store from '../store'
import {defaultData, siteInfos} from '../assets/js/common'

let baseURL = ''
if (process.env.NODE_ENV === 'development') { // 开发环境
  baseURL = defaultData.schoolApiURL;
} else {
  baseURL = defaultData.schoolApiURL
}

axios.defaults.timeout = 6000
axios.defaults.baseURL = baseURL
axios.defaults.responseType = "json"
axios.defaults.withCredentials = true

const Axios = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  responseType: "json",
  withCredentials: true
});

let localhost = location.host;
window.localhost = localhost;
Axios.interceptors.request.use((config) => {
  // config.headers["appkey"] ="...";
  // config.headers["token"] ="...";

  // if (config.method == "post") {
  // 	config.data = qs.stringify(config.data)
  // }
  return config;
}, (error) => {
  return Promise.reject(error)
})


window.cookieDomain = siteInfos.secondDomain;
Axios.interceptors.response.use((res) => {
  let url = res.config.url.split('/');
  if(res.data.data.code == -1) {
    if(url[3] == 'user'){
      Cookies.remove('useruid', { domain: window.cookieDomain });
      Cookies.remove('userstr', { domain: window.cookieDomain });
      Cookies.remove('userlevel', { domain: window.cookieDomain });
      if(location.pathname == '/' && Cookies.get('userstr') && store.state.user.userstr) throw 'user abnormal exit'; // 异常退出
      if(location.pathname != '/') Cookies.set('_user_redirect_url', window.location.href);
      setTimeout(function(){
        if(location.pathname != '/' && res.config.data != "is_verify=true") window.location.href = "/";
      }, 500);
    }else if(url[3] == 'jigou') {
      Cookies.remove('uid', { domain: window.cookieDomain });
      Cookies.remove('phone', { domain: window.cookieDomain });
      Cookies.set('redirect_url', window.location.href);
      window.location.href = "/jigou";
    }else{
      if(location.pathname != '/' && location.pathname != '/jigou' && res.config.data != "is_verify=true") {
        window.location.href = "/";
      }
    }
  }

  if(res.data.data.code == -101){
    document.getElementsByTagName('body')[0].style.visibility='hidden';
    document.getElementsByTagName('body')[0].innerHTML = "<div style='width:100%;text-align: center;font-size: 24px;color:#c9242b;margin-top:36px;line-height:30px;font-weight: bold;'>非常抱歉，我们的系统正在紧急维护，预计20分钟内完成，给您带来的不便敬请谅解！</div>"
    document.getElementsByTagName('body')[0].style.visibility='unset';
    return;
  }
  // 个人版：如果是普通用户则只能访问非会员页面
  if (res.status === 200 && res.data && res.data.status === true) {
    return Promise.resolve(res.data.data)
  } else if (res.status === 200 && res.data && res.data.status === false) {
    return Promise.reject(res.data)
  } else {
    return Promise.reject(res)
  }
}, (error) => {
  Vue.prototype.$message.error('网络错误')
  return Promise.reject(error)
})

export function get(url, datas = {}) {
  var end_link = '?';
  if (url.indexOf('?') > -1) end_link = '&';
  return Axios({
    url: url,
    method: "get",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    params: datas
  })
}

export function post(url, datas = {}) {
  return Axios({
    url: url,
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data: qs.stringify(datas)
  });
}

export function custorm(url, datas = {}, headerData = {}) {
  return Axios({
    url: url,
    method: "post",
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    data: datas
  });
}



// WEBPACK FOOTER //
// ./src/api/axios.js